import {Options} from "highcharts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";

export default abstract class AbstractWavesColumn extends AbstractChart {

    constructor(target: HTMLElement) {
        super(target);

    }
    protected allChartOptions(): Options {
        return super.mergeOptions(
            super.allChartOptions(), {
                chart: {
                    type: 'column',
                    height: 180
                },
                legend: {
                    enabled: false
                },
                xAxis: {
                    labels: {
                        style: {
                            fontSize: '1rem'
                        }
                    }
                },
                yAxis: {
                    tickInterval: 50,
                },
                plotOptions: {
                    series: {
                        states: {
                            inactive: {
                                opacity: 1
                            }
                        }
                    },
                    column: {
                        maxPointWidth: 35,
                        stacking: 'percent',
                    },
                    line: {
                        tooltip: {
                            enabled: false
                        },
                        states: {
                            hover: {
                                enabled: false
                            }
                        }

                    }
                },
                tooltip: {
                    enabled: true,
                    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                    followPointer: true,
                    positioner: function (labelWidth, labelHeight, point) {
                        let tooltipX = point.plotX + this.chart.plotLeft - labelWidth - 15;
                        let tooltipY = point.plotY + this.chart.plotTop - (labelHeight / 2);

                        // Ensure the tooltip stays within the chart boundaries
                        if (tooltipX < 0) {
                            tooltipX = 0;
                        } else if (tooltipX + labelWidth > this.chart.chartWidth) {
                            tooltipX = this.chart.chartWidth - labelWidth;
                        }

                        if (tooltipY < 0) {
                            tooltipY = 0;
                        } else if (tooltipY + labelHeight > this.chart.chartHeight) {
                            tooltipY = this.chart.chartHeight - labelHeight;
                        }

                        return {
                            x: tooltipX,
                            y: tooltipY
                        };
                    },
                    formatter: function () {
                        if (this.series.type === 'line') {
                            return `M=${this.point.y}%`;
                        }
                        return `${this.series.options.tooltipText}<br>
                ${this.point.percentage.toFixed(1)}%`;
                    }
                },
            }
        );
    }
}
